/* eslint-disable @typescript-eslint/no-namespace */
import { apiClientResp } from '../merchant/error.js';
import { claimAddress, locationAddress, orderAddress, } from '../schema/address.js';
import { claim, claimCreate, tag } from '../schema/claim.js';
import { claimLineItemCreate, variantExchangeLineItem, } from '../schema/claimLineItem.js';
import { afterReasonSelectionQuery, automationLineItem, beforeClaimSubmissionBody, } from '../schema/claimSubmissionEvent.js';
import { customerUiEventCustomField, customUiCustomField, customUiCustomFieldSelect, } from '../schema/customField.js';
import { crewOrder, crewOrderLineItem, storeOrder } from '../schema/order.js';
import { registration, registrationCreate } from '../schema/registration.js';
import { shipment, shipmentCreate, shipmentQuoteBody, } from '../schema/shipment.js';
import { rate, returnShipmentMethod } from '../schema/shipmentRate.js';
import { shippingClaimCreateCustomer, shippingClaimCreateMerchant, shippingClaimCustomerUi, } from '../schema/shippingClaim/shippingClaim.js';
import { signedUrl } from '../schema/signedUrl.js';
import { registrationProduct } from '../schema/storeProduct.js';
import { orderTracker } from '../schema/tracking.js';
import { paymentIntent, paymentIntentCreate } from './schema/payment.js';
import { monetarySettings, settings, } from './schema/settings.js';
import { collection, productOptions, variantExchange, variantExchangeOptions, } from './schema/variantExchange.js';
/**
 * CrewUi types for the crew-customer-ui
 * Utility types to be used in conjunction with the crewCustomerUiApi
 */
export var CrewUi;
(function (CrewUi) {
    CrewUi.REF_QUERY_PARAM = 'ref';
    // ? urls in use by the backend API for direct linking  to the crew-customer-ui
    CrewUi.frontEndUrlPaths = [
        // SLUG branded URLS
        ':slug/claim/overview/:claimExternalId', // CREW claim overview
        ':slug/order/:idFromPlatform', // order hub
        ':slug/reorder/:idFromPlatform', // branded start a gsp reorder
        ':slug/reorder/:idFromPlatform/claim/:shippingClaimId', // shipping claim overview
        'reorder/:idFromPlatform', // start a reorder without a slug
        ':slug/register', // branded registration page
    ];
    CrewUi.variantExchangeSchema = variantExchange;
    CrewUi.variantExchangeOptionsSchema = variantExchangeOptions;
    CrewUi.variantExchangeProductOptionsSchema = productOptions;
    CrewUi.collectionSchema = collection;
    CrewUi.paymentIntentSchema = paymentIntent;
    CrewUi.paymentIntentCreateSchema = paymentIntentCreate;
    CrewUi.customFieldSelectSchema = customUiCustomFieldSelect;
    CrewUi.customFieldGeneralSchema = customUiCustomField;
    CrewUi.collectCustomFieldEventSchema = customerUiEventCustomField;
    CrewUi.claimSchema = claim;
    CrewUi.claimTagSchema = tag;
    CrewUi.variantExchangeLineItemSchema = variantExchangeLineItem;
    CrewUi.claimAddressSchema = claimAddress;
    CrewUi.claimCreateSchema = claimCreate;
    CrewUi.claimLineItemCreateSchema = claimLineItemCreate;
    CrewUi.registrationSchema = registration;
    CrewUi.registrationCreateSchema = registrationCreate;
    CrewUi.registrationProductSchema = registrationProduct;
    CrewUi.orderSchema = crewOrder;
    CrewUi.crewOrderLineItemSchema = crewOrderLineItem;
    CrewUi.orderAddressSchema = orderAddress;
    CrewUi.orderTrackerSchema = orderTracker;
    CrewUi.signedUrlSchema = signedUrl;
    CrewUi.settingsSchema = settings;
    CrewUi.monetarySettingsSchema = monetarySettings;
    CrewUi.shipmentQuoteSchema = shipmentQuoteBody;
    CrewUi.shipmentRateSchema = rate;
    CrewUi.shipmentMethodSchema = returnShipmentMethod;
    CrewUi.shipmentCreateSchema = shipmentCreate;
    CrewUi.shipmentSchema = shipment;
    CrewUi.locationAddressSchema = locationAddress;
    CrewUi.apiClientRespSchema = apiClientResp;
    CrewUi.shippingClaimSchema = shippingClaimCustomerUi;
    CrewUi.shippingClaimCreateCustomerSchema = shippingClaimCreateCustomer;
    CrewUi.shippingClaimCreateMerchantSchema = shippingClaimCreateMerchant;
    CrewUi.gspOrderSchema = storeOrder;
    CrewUi.afterReasonSelectionQuerySchema = afterReasonSelectionQuery;
    CrewUi.automationLineItemSchema = automationLineItem;
    CrewUi.beforeClaimSubmissionBodySchema = beforeClaimSubmissionBody;
})(CrewUi || (CrewUi = {}));
//# sourceMappingURL=schema.js.map